import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";

import { queryClient } from "App";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { getNextQueryParams } from "components/helpers";
import useMetaSyncInProgress, {
  META_SYNC_POLL_INTERVAL_MS,
} from "hooks/useMetaSyncInProgress";
import MetaAdSetService from "services/MetaAdSet";

const adSetsQueryKey = accountId => ["meta-ad-sets", accountId];

const AD_SET_COLUMNS = [
  {
    header: "ID",
    id: "ID",
    accessorKey: "id",
    size: 50,
    cell: ({ row }) => (
      <p style={{ fontWeight: "bold" }}>{row.getValue("ID")}</p>
    ),
  },
  { id: "Name", accessorKey: "name", header: "Name", size: 220 },
  { id: "Status", accessorKey: "status", header: "Status", size: 120 },
  {
    id: "Delivery",
    accessorKey: "effective_status",
    header: "Delivery",
    size: 140,
  },
  {
    id: "Optimization",
    accessorKey: "optimization_goal",
    header: "Optimization",
    size: 180,
  },
  { id: "Billing", accessorKey: "billing_event", header: "Billing", size: 150 },
  {
    id: "Daily Budget",
    accessorKey: "daily_budget",
    header: "Daily Budget",
    size: 130,
  },
];

const MetaAdSetsTab = () => {
  const { accountId } = useParams();

  const columns = useMemo(() => AD_SET_COLUMNS, []);
  const isSyncing = useMetaSyncInProgress(accountId, "live");

  const invalidateAdSets = useCallback(
    () =>
      queryClient.invalidateQueries({ queryKey: adSetsQueryKey(accountId) }),
    [accountId]
  );

  const fetchAdSets = useCallback(
    async queryParams => {
      const next = getNextQueryParams(queryParams, columns);
      return MetaAdSetService.list(accountId, next);
    },
    [accountId, columns]
  );

  return (
    <div className="tw:flex tw:flex-col tw:flex-1 tw:min-h-0 tw:min-w-0">
      <BaseTableV3
        columns={columns}
        header="Ad Sets"
        tableName="meta_ad_sets"
        queryKey={adSetsQueryKey(accountId)}
        fetchData={fetchAdSets}
        invalidateData={invalidateAdSets}
        refetchInterval={isSyncing ? META_SYNC_POLL_INTERVAL_MS : undefined}
        enableSearch
        enableSettings
      />
    </div>
  );
};

export default MetaAdSetsTab;
